// Author YuJiaBei
// Date 2021-06-21 17:50:20

class EmOpcComputedTypeEoct {
constructor({
        id = null,
        eoctName = '',
        remark = ''}
= {}) {
    this.id = id;
    this.eoctName = eoctName;
    this.remark = remark;
}
}

function newEntity() {
return new EmOpcComputedTypeEoct();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.base.opcClient.emOpcComputedTypeEoct.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eoctName',
        label: 'label.em.base.opcClient.emOpcComputedTypeEoct.grid.eoctName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.base.opcClient.emOpcComputedTypeEoct.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    eoctNameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'eoctNameFilter',
        label: 'label.em.base.opcClient.emOpcComputedTypeEoct.filter.eoctName',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'eoctName',
        label: 'label.em.base.opcClient.emOpcComputedTypeEoct.entity.eoctName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.em.base.opcClient.emOpcComputedTypeEoct.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmOpcComputedTypeEoct, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
